/* Product gallery enhancement. Venture retains modal opening, Escape and focus return. */
(function () {
  'use strict';
  function init() {
    var modal = document.getElementById('ProductModal');
    if (!modal || modal.dataset.ptGalleryReady) return;
    var stage = modal.querySelector('.ptpg-stage');
    var img = modal.querySelector('#ProductZoomImg');
    if (!stage || !img) return;
    var anchors = Array.from(document.querySelectorAll('.product-single .photos .product__photo-wrapper.js-modal-open-product-modal'));
    var images = [], galleryIndices = new Map();
    anchors.forEach(function (anchor) {
      var source = anchor.href;
      var imageIndex = images.findIndex(function (item) { return item.src === source; });
      if (imageIndex < 0) {
        imageIndex = images.length;
        images.push({src: source, alt: (anchor.querySelector('img') || {}).alt || img.alt});
      }
      galleryIndices.set(anchor, imageIndex);
    });
    if (!images.length) return;
    modal.dataset.ptGalleryReady = 'true';
    var count = modal.querySelector('[data-ptpg-count]');
    var reset = modal.querySelector('[data-ptpg-reset]');
    var minus = modal.querySelector('[data-ptpg-minus]');
    var plus = modal.querySelector('[data-ptpg-plus]');
    var error = modal.querySelector('[data-ptpg-error]');
    var index = 0, scale = 1, panX = 0, panY = 0, wasOpen = false;
    var pointers = new Map(), gesture = null, pinch = null;
    var lastTap = null, suppressClickUntil = 0, wheelTotal = 0, lastWheel = 0, lastWheelInput = 0;
    var maxScale = 3;
    function isOpen() { return modal.classList.contains('modal--is-active'); }
    function clamp(value, min, max) { return Math.max(min, Math.min(max, value)); }
    function center() {
      var rect = stage.getBoundingClientRect();
      return {x: rect.left + rect.width / 2, y: rect.top + rect.height / 2};
    }
    function paint() {
      var boundX = Math.max(0, (img.offsetWidth * scale - stage.clientWidth) / 2);
      var boundY = Math.max(0, (img.offsetHeight * scale - stage.clientHeight) / 2);
      panX = clamp(panX, -boundX, boundX);
      panY = clamp(panY, -boundY, boundY);
      img.style.setProperty('--ptpg-transform', 'translate(' + panX + 'px,' + panY + 'px) scale(' + scale + ')');
      modal.classList.toggle('ptpg-zoomed', scale > 1.01);
      reset.textContent = Math.round(scale * 100) + ' %';
      reset.setAttribute('aria-label', 'Zoom ' + Math.round(scale * 100) + ' Prozent. Zurücksetzen');
      minus.disabled = scale <= 1;
      plus.disabled = scale >= maxScale;
    }
    function zoom(next, point) {
      next = clamp(next, 1, maxScale);
      var origin = center();
      var focal = point || origin;
      panX = focal.x - origin.x - (focal.x - origin.x - panX) * next / scale;
      panY = focal.y - origin.y - (focal.y - origin.y - panY) * next / scale;
      scale = next;
      paint();
    }
    function resetZoom() { scale = 1; panX = 0; panY = 0; lastTap = null; paint(); }
    function ready() { stage.removeAttribute('aria-busy'); paint(); }
    img.addEventListener('load', ready);
    img.addEventListener('error', function () {
      stage.removeAttribute('aria-busy');
      if (isOpen()) error.hidden = false;
    });
    function show(next) {
      index = (next + images.length) % images.length;
      resetZoom();
      error.hidden = true;
      stage.setAttribute('aria-busy', 'true');
      img.alt = images[index].alt;
      if (img.src !== images[index].src) img.src = images[index].src;
      count.textContent = 'Bild ' + (index + 1) + ' von ' + images.length;
      if (img.complete && img.naturalWidth) ready();
      if (images.length > 1) {
        var preload = new Image();
        preload.src = images[(index + 1) % images.length].src;
      }
    }
    function bind(selector, action) {
      var button = modal.querySelector(selector);
      button.addEventListener('click', function (event) {
        event.preventDefault();
        event.stopPropagation(); // Venture otherwise treats control clicks as backdrop clicks.
        action();
      });
      return button;
    }
    bind('[data-ptpg-prev]', function () { show(index - 1); }).hidden = images.length < 2;
    bind('[data-ptpg-next]', function () { show(index + 1); }).hidden = images.length < 2;
    bind('[data-ptpg-minus]', function () { zoom(scale - 0.5); });
    bind('[data-ptpg-plus]', function () { zoom(scale + 0.5); });
    bind('[data-ptpg-reset]', resetZoom);
    modal.querySelector('.ptpg-tools').addEventListener('click', function (event) { event.stopPropagation(); });
    count.addEventListener('click', function (event) { event.stopPropagation(); });
    // Capture the selected main photo before the theme opens the modal.
    document.addEventListener('click', function (event) {
      var anchor = event.target.closest && event.target.closest('.product__photo-wrapper.js-modal-open-product-modal');
      if (!anchor || anchors.indexOf(anchor) < 0) return;
      // Marketing scripts may decorate hrefs after initialization; identity stays stable.
      index = galleryIndices.get(anchor);
    }, true);
    new MutationObserver(function () {
      var open = isOpen();
      if (open === wasOpen) return;
      wasOpen = open;
      pointers.clear(); gesture = null; pinch = null; wheelTotal = 0;
      if (open) show(index); else resetZoom();
    }).observe(modal, {attributes: true, attributeFilter: ['class']});
    modal.addEventListener('keydown', function (event) {
      if (!isOpen() || event.altKey || event.metaKey || event.ctrlKey) return;
      var handled = true;
      if (event.key === 'ArrowRight') show(index + 1);
      else if (event.key === 'ArrowLeft') show(index - 1);
      else if (event.key === 'Home') show(0);
      else if (event.key === 'End') show(images.length - 1);
      else if (event.key === '+' || event.key === '=') zoom(scale + 0.5);
      else if (event.key === '-') zoom(scale - 0.5);
      else if (event.key === '0') resetZoom();
      else if (event.key === 'Tab') {
        var buttons = Array.from(modal.querySelectorAll('button')).filter(function (button) { return !button.hidden && !button.disabled; });
        var first = buttons[0], last = buttons[buttons.length - 1];
        if (event.shiftKey && (document.activeElement === first || document.activeElement === modal)) last.focus();
        else if (!event.shiftKey && document.activeElement === last) first.focus();
        else handled = false;
      } else handled = false;
      if (handled) { event.preventDefault(); event.stopPropagation(); }
    });
    function startGesture(point, onImage, fromPinch) {
      gesture = {x: point.x, y: point.y, panX: panX, panY: panY, moved: false, pinch: !!fromPinch, onImage: onImage};
    }
    stage.addEventListener('pointerdown', function (event) {
      if (!isOpen() || event.button > 0) return;
      var point = {x: event.clientX, y: event.clientY};
      pointers.set(event.pointerId, point);
      stage.setPointerCapture(event.pointerId);
      if (pointers.size === 1) startGesture(point, event.target === img, false);
      if (pointers.size === 2) {
        var pair = Array.from(pointers.values());
        var origin = center();
        pinch = {distance: Math.max(1, Math.hypot(pair[1].x - pair[0].x, pair[1].y - pair[0].y)), scale: scale,
          x: ((pair[0].x + pair[1].x) / 2 - origin.x - panX) / scale,
          y: ((pair[0].y + pair[1].y) / 2 - origin.y - panY) / scale};
        gesture.pinch = true;
      }
    });
    stage.addEventListener('pointermove', function (event) {
      if (!pointers.has(event.pointerId)) return;
      pointers.set(event.pointerId, {x: event.clientX, y: event.clientY});
      if (pointers.size >= 2 && pinch) {
        var pair = Array.from(pointers.values()), origin = center();
        scale = clamp(pinch.scale * Math.hypot(pair[1].x - pair[0].x, pair[1].y - pair[0].y) / pinch.distance, 1, maxScale);
        panX = (pair[0].x + pair[1].x) / 2 - origin.x - pinch.x * scale;
        panY = (pair[0].y + pair[1].y) / 2 - origin.y - pinch.y * scale;
        paint();
      } else if (gesture) {
        var dx = event.clientX - gesture.x, dy = event.clientY - gesture.y;
        if (Math.hypot(dx, dy) > 8) gesture.moved = true;
        if (scale > 1) { panX = gesture.panX + dx; panY = gesture.panY + dy; paint(); }
      }
    });
    function pointerEnd(event) {
      if (!pointers.has(event.pointerId)) return;
      pointers.delete(event.pointerId);
      var cancelled = event.type === 'pointercancel';
      if (pointers.size === 0 && gesture) {
        var dx = event.clientX - gesture.x, dy = event.clientY - gesture.y;
        if (gesture.moved || gesture.pinch) suppressClickUntil = Date.now() + 450;
        if (!cancelled && !gesture.pinch) {
          if (scale === 1 && Math.abs(dx) > 55 && Math.abs(dx) > Math.abs(dy) * 1.25) show(index + (dx < 0 ? 1 : -1));
          else if (!gesture.moved && gesture.onImage && event.pointerType === 'touch') {
            var now = Date.now();
            if (lastTap && now - lastTap.at < 320 && Math.hypot(event.clientX - lastTap.x, event.clientY - lastTap.y) < 30) {
              zoom(scale > 1 ? 1 : 2, {x: event.clientX, y: event.clientY});
              lastTap = null;
            } else lastTap = {at: now, x: event.clientX, y: event.clientY};
          }
        }
        // Pointer capture can retarget clicks from the image to the stage.
        if (gesture.onImage) suppressClickUntil = Date.now() + 450;
        gesture = null; pinch = null;
      } else if (pointers.size === 1) {
        startGesture(Array.from(pointers.values())[0], true, true);
        pinch = null;
      }
    }
    stage.addEventListener('pointerup', pointerEnd);
    stage.addEventListener('pointercancel', pointerEnd);
    stage.addEventListener('click', function (event) {
      if (event.target === img || Date.now() < suppressClickUntil) event.stopPropagation();
    });
    stage.addEventListener('dblclick', function (event) {
      event.preventDefault(); event.stopPropagation();
      zoom(scale > 1 ? 1 : 2, {x: event.clientX, y: event.clientY});
    });
    stage.addEventListener('dragstart', function (event) { event.preventDefault(); });
    stage.addEventListener('wheel', function (event) {
      if (!isOpen()) return;
      event.preventDefault();
      var unit = event.deltaMode === 1 ? 16 : event.deltaMode === 2 ? stage.clientHeight : 1;
      var dx = event.deltaX * unit, dy = event.deltaY * unit;
      if (event.ctrlKey) {
        zoom(scale * Math.exp(-dy * 0.01), {x: event.clientX, y: event.clientY});
      } else if (scale > 1) {
        panX -= dx; panY -= dy; paint();
      } else if (images.length > 1) {
        var now = Date.now(), delta = Math.abs(dx) > Math.abs(dy) ? dx : dy;
        if (now - lastWheel < 550) return;
        if (now - lastWheelInput > 1200 || Math.sign(delta) !== Math.sign(wheelTotal)) wheelTotal = 0;
        lastWheelInput = now;
        wheelTotal += delta;
        if (Math.abs(wheelTotal) >= 65) { show(index + (wheelTotal > 0 ? 1 : -1)); lastWheel = now; wheelTotal = 0; }
      }
    }, {passive: false});
    window.addEventListener('resize', function () { if (isOpen()) paint(); });
    paint();
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
